module.exports = __webpack_public_path__ + "img/cns_email_ios3.1bcf9b5c.png";